import type {CmLogger} from "@cm/log"

export const ignoreIfComponentDestroyed = (error: unknown) => {
    if (error instanceof Error && error.message.startsWith("NG0911:")) {
        // This is expected: some of our lifecycle hooks take so long that the component might be destroyed by the time
        // they complete, resulting in this error.
        // See also https://github.com/angular/angular/issues/54527
        componentLifecycleLogger?.info("Component already destroyed")
        return
    }
    throw error
}

export let componentLifecycleLogger: CmLogger | undefined
